module.exports = __webpack_public_path__ + "img/404.016e0dd4.png";